var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 468.2 109",
    style: {
      enableBackground: "new 0 0 468.2 109"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "179.6,0 173.3,0 143.1,45.4 152.7,45.4 176.5,8.8 199.9,45.4 209.6,45.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "268,45.4 268,0 259.4,0 259.4,18.1 222.3,18.1 222.3,0 213.7,0 213.7,45.4 222.3,45.4 222.3,24.7  259.4,24.7 259.4,45.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "284.3,13.7 307.5,45.4 314.5,45.4 337.5,13.6 337.5,45.4 345.5,45.4 345.5,0 338.1,0 311.3,37.1  284.4,0 276.4,0 276.4,45.4 284.3,45.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "400.5,38.7 362.4,38.7 362.4,24.7 398.6,24.7 398.6,18.1 362.4,18.1 362.4,6.7 400.5,6.7 400.5,0  353.9,0 353.9,45.4 400.5,45.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M466.1,32.4v-19c0-9-3.9-13.4-16.8-13.4h-41.6v45.4l41.6,0C462.2,45.4,466.1,40.9,466.1,32.4z M416.4,6.7h33 c6.4,0,8.2,1.5,8.2,6.7v19c0,4.8-1.8,6.3-8.2,6.3h-33V6.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "141.1,70.4 164.9,70.4 164.9,109 173.5,109 173.5,70.4 196.6,70.4 196.6,63.6 141.1,63.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M240.9,63.6h-38.5V109h8.6V88.8h23.9l10.6,20.2h9.1l-10.7-20.3c8.1-0.8,11.2-5,11.2-10.8v-3.2 C255.1,68.1,251.2,63.6,240.9,63.6z M246.6,77.9c0,2.7-1.8,4.2-5.7,4.2h-30V70.3h30c3.9,0,5.7,1.5,5.7,4.2V77.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M306,63.6h-30c-10.3,0-14.2,4.5-14.2,11V98c0,6.6,3.9,11,14.2,11l30,0.1c10.3,0,14.3-4.5,14.3-11V74.6 C320.3,68,316.3,63.6,306,63.6z M306,102.3h-30c-3.9,0-5.7-1.5-5.7-4.2V74.5c0-2.7,1.8-4.2,5.7-4.2h29.9c3.9,0,5.7,1.5,5.7,4.2 l0.1,23.6C311.7,100.8,309.9,102.3,306,102.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M376.1,98.1c0,2.7-1.8,4.2-5.7,4.2h-28.2c-3.9,0-5.7-1.5-5.7-4.2V63.6H328v34.4c0,6.5,4,10.9,14.3,10.9 l29.9,0.1c10.3,0,12.4-4.5,12.4-11V63.6h-8.6V98.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M434.5,63.6h-41.6V109l41.6,0c12.8,0,16.8-4.5,16.8-13v-19C451.2,68.1,447.3,63.6,434.5,63.6z M442.6,96 c0,4.8-1.8,6.3-8.2,6.3h-33v-32h33c6.4,0,8.2,1.5,8.2,6.7V96z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.6,
    y: 63.6,
    className: "st0",
    width: 8.6,
    height: 45.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.5,66.4C8.5,66.2,0.1,77.1,0,87.6c-0.1,12.5,11.5,21.7,21.5,21.2c0.2,0,0.5,0,0.7,0 c11.6-0.2,20.8-9.7,20.6-21.3C42.6,75.9,34.7,66.6,21.5,66.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.2,24.1h-5.7c-10.9,0-20.7-6.8-24.5-17l-0.5-1.5l-1.4-4.2C72.8,0.3,72.3,0,71.3,0H32.5 c-1.4,0-1.4,0.1-0.9,1.6L67,106.4c0.6,2.1,1.3,2.5,3.3,2.5c5.9-0.1,11.8,0,17.7,0c6.4,0,12.8,0,19.3,0c1.4,0,2.2,0.1,1.2-1.9 l-20-59.9H113L105.2,24.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9e7837005074ded09d2bb1bef0e8ae14.svg";
export { ForwardRef as ReactComponent };